import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import "../styles/MovieCard.scss"; // make sure you import the style file

const MovieCard = ({ movie }) => {
  const navigate = useNavigate();
  const [showTrailer, setShowTrailer] = useState(false);

  const handleViewDetails = () => {
    navigate(`/movie/${movie.slug}`);
  };

  return (
    <div className="upcoming-movie-card">
      <div className="upcoming-movie-image-wrapper">
        <img
          src={movie.thumbnail}
          alt={movie.name}
          className="upcoming-movie-image"
        />
        <div className="upcoming-movie-trailer">
          <button
            className="upcoming-movie-trailer-btn"
            onClick={() => setShowTrailer(true)}
          >
            View Trailer
          </button>
          <button
            className="upcoming-movie-details-btn"
            onClick={handleViewDetails}
          >
            View Details
          </button>
        </div>
      </div>

      <div className="upcoming-movie-card-content">
        <div className="upcoming-movie-title">{movie.name}</div>
        <div className="upcoming-movie-genre">
          {movie.genre?.map((g) => g.name).join(", ")}
        </div>
      </div>

      {/* 🎥 Trailer Modal */}
      {showTrailer && (
        <div className="video-modal" onClick={() => setShowTrailer(false)}>
          <div className="video-wrapper" onClick={(e) => e.stopPropagation()}>
            <video width="100%" height="400" controls autoPlay>
              <source src={movie.trailer} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button
              className="btn-close"
              onClick={() => setShowTrailer(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MovieCard;
